import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";
import moment from "moment";

interface ModalShowProgramProps {
  show: boolean;
  onHide: () => void;
  id_program: number | null;
}

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ModalShowProgram: React.FC<ModalShowProgramProps> = ({
  show,
  onHide,
  id_program,
}) => {
  const [formData, setFormData] = useState({
  id_program: "",
  id_user: "",
  program_date: "",
  date_creation: "",
  status: "",
  type: "",
  observation: "",
  departure: "",
  destination: "",
  nom_conducteur: "",
  prenom_conducteur: "",
  immatriculation_vehicule: "",
  client_name: ""
  });

  const { translate } = useTranslate();

  const getprogramById = async (id_program: number) => {
    try {
      const response = await fetch(
        `${backendUrl}/api/program/find/${id_program}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );

      if (!response.ok) {
        throw new Error("Error retrieving program");
      }

      const program = await response.json();
      return program || null;
    } catch (error) {
      console.error("Error retrieving program :", error);
      return null;
    }
  };

  useEffect(() => {
    if (show && id_program) {
      getprogramById(id_program).then((program) => {
         const p = Array.isArray(program) ? program[0] : program;
        if (p) {
          setFormData({
              id_program: p.id_program || "",
              id_user: p.id_user || "",
              program_date: p.program_date 
                ? moment(p.program_date).format("YYYY-MM-DD") : "",
              date_creation: p.date_creation 
                ? moment(p.date_creation).format("YYYY-MM-DD") : "",
              status: p.status || "",
              type: p.type || "",
              observation: p.observation || "",
              departure: p.departure || "",
              destination: p.destination || "",
              nom_conducteur: p.nom_conducteur || "",
              prenom_conducteur: p.prenom_conducteur || "",
              immatriculation_vehicule: p.immatriculation_vehicule || "",
              client_name: p.client_name || ""
          });
        }
      });
    }
  }, [show, id_program]);

  // Génération automatique de la description avec traduction
  const generatedDescription = (() => {
    const highlight = (value: any) => <span className="text-blue-500 font-semibold">{value}</span>;

      <>
    {translate("Program scheduled for")}{" "}
    <strong>{formData.nom_conducteur} {formData.prenom_conducteur}</strong>{" "}
    {formData.immatriculation_vehicule && (
      <>({formData.immatriculation_vehicule}) </>
    )}
    {translate("from")} <strong>{formData.departure}</strong>{" "}
    {translate("to")} <strong>{formData.destination}</strong>{" "}
    {translate("on")} <strong>{formData.program_date}</strong>.
  </>
  })();

  return (
    <Modal show={show} onHide={onHide} responsive>
      <Modal.Header closeButton>
        <Modal.Title>{translate(formData.status)}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "calc(80vh - 200px)", overflowY: "auto" }}>
        <Form style={{
          color: "#000",
          fontSize: "18px"
        }}>
          <Form.Group>
            <Form.Label>{translate("Program date")} :</Form.Label>
            <p className="form-text">{formData.program_date}</p>
          </Form.Group>

          {/*<Form.Group>
            <Form.Label>{translate("Description")} :</Form.Label>
            <p className="form-text">{<>{generatedDescription}</>}</p>
          </Form.Group>*/}
        <Form.Group>
            <Form.Label>{translate("Client")} :</Form.Label>
            <p className="form-text">{formData.client_name}</p>
          </Form.Group>

          <Form.Group>
            <Form.Label>{translate("Status")} :</Form.Label>
            <p className="form-text">{translate(formData.status)}</p>
          </Form.Group>

          <Form.Group>
            <Form.Label>{translate("program for")} :</Form.Label>
            <p className="form-text"> {formData.immatriculation_vehicule}</p>
          </Form.Group>

          { <Form.Group>
            <Form.Label>{translate("Conducteur")} :</Form.Label>
            <p className="form-text">
              {formData.nom_conducteur} {formData.prenom_conducteur}
            </p>
          </Form.Group> }

        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {translate("Close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalShowProgram;